import { render, staticRenderFns } from "./platform_edit.vue?vue&type=template&id=ced2cea0&"
import script from "./platform_edit.vue?vue&type=script&lang=js&"
export * from "./platform_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports